/**
 * Centralized Cart Refresh System
 * Ensures cart drawer, bubble, and progress bar all update together
 */

window.refreshCart = async function() {
  console.log('🔄 Refreshing cart...');

  try {
    // Fetch cart data and sections in parallel
    const [cartResponse, sectionsResponse] = await Promise.all([
      fetch('/cart.js'),
      fetch(`${window.location.pathname}?sections=cart-drawer,cart-bubble`)
    ]);

    const cart = await cartResponse.json();
    const sections = await sectionsResponse.json();

    console.log('Cart data fetched:', { itemCount: cart.item_count, total: cart.total_price });

    // Update cart drawer
    if (sections['cart-drawer']) {
      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const newInner = doc.querySelector('.side-panel-inner');
        const currentInner = cartDrawer.querySelector('.side-panel-inner');

        if (newInner && currentInner) {
          console.log('✅ Updating cart drawer content');
          currentInner.replaceWith(newInner);
        } else {
          console.error('❌ Could not find drawer elements:', { newInner, currentInner });
        }
      }
    }

    // Update cart bubble
    if (sections['cart-bubble']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections['cart-bubble'], 'text/html');
      const newBubble = doc.querySelector('.thb-item-count');
      const currentBubble = document.querySelector('.thb-item-count');

      if (newBubble && currentBubble) {
        console.log('✅ Updating cart bubble');
        currentBubble.replaceWith(newBubble);
      }
    }

    // Update progress bar with fresh cart total
    const progressBar = document.querySelector('unified-progress-bar');
    if (progressBar) {
      console.log('✅ Updating progress bar with total:', cart.total_price);
      progressBar.dataset.cartTotal = cart.total_price;
      if (typeof progressBar.updateProgress === 'function') {
        progressBar.updateProgress();
      }
    }

    // Dispatch completion event
    document.dispatchEvent(new CustomEvent('cart:refreshed', {
      detail: { cart }
    }));

    console.log('✅ Cart refresh complete');
    return cart;

  } catch (error) {
    console.error('❌ Error refreshing cart:', error);
    throw error;
  }
};
